<template>
  <div class="w-full h-full overflow-hidden">
    <div class="drawer h-full overflow-hidden">
      <input id="my-drawer-3" type="checkbox" class="drawer-toggle" />
      <div class="h-full overflow-hidden drawer-content flex flex-col">
        <div class="flex h-full overflow-hidden">
          <div class="hidden lg:block w-56 h-full bg-base-200" v-if="showNav">
            <div class="flex flex-col h-full justify-between">
              <div>
                <div class="h-16 flex items-center">
                  <div class="flex-1 px-4 mx-2">Surtly</div>
                </div>
                <Navigation :isMobile="false" />
              </div>
              <div>
                <ul
                  v-if="
                    route && route.name && route.name.startsWith('Provider_')
                  "
                  class="pl-2 menu w-56 h-full"
                >
                  <li v-if="canAccessBilling">
                    <button
                      class="flex items-center gap-3 px-4 py-2 rounded-lg text-left hover:bg-base-300"
                      :disabled="billingActionInFlight"
                      :class="billingActionInFlight ? 'opacity-60 cursor-not-allowed' : ''"
                      @click="handleBillingClick"
                    >
                      <CreditCardIcon class="h-5 w-5" aria-hidden="true" />
                      <span>Billing</span>
                    </button>
                  </li>

                  <li>
                    <button
                      class="flex items-center gap-3 px-4 py-2 rounded-lg text-left"
                      @click="logout()"
                    >
                      <ArrowRightStartOnRectangleIcon
                        class="h-5 w-5"
                        aria-hidden="true"
                      />
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="w-full h-full flex flex-col overflow-hidden">
            <div class="w-full navbar flex lg:hidden" v-if="showNav">
              <div class="flex-none block lg:hidden">
                <label
                  for="my-drawer-3"
                  aria-label="open sidebar"
                  class="btn btn-square btn-ghost no-animation"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    class="inline-block w-6 h-6 stroke-current"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    ></path>
                  </svg>
                </label>
              </div>
              <div class="flex-1 px-2 mx-2">
                <p class="block lg:hidden">Surtly</p>
              </div>
            </div>
            <router-view
              class="pt-0 h-full overflow-y-scroll"
              :class="
                route && route.name && route.name.includes('Home')
                  ? 'lg:pt-0'
                  : 'lg:pt-6'
              "
            />
          </div>
        </div>
      </div>
      <div class="drawer-side">
        <label
          for="my-drawer-3"
          aria-label="close sidebar"
          class="drawer-overlay"
        ></label>
        <div @click="toggle" class="w-80 flex flex-col h-full bg-base-200">
          <div class="flex flex-col h-full justify-between">
            <div class="flex items-center" style="height: 69px !important">
              <div class="flex-1 px-4">
                <p class="">Surtly</p>
              </div>
            </div>
            <Navigation :isMobile="true" />
          </div>
          <div>
            <ul
              v-if="route && route.name && route.name.startsWith('Provider_')"
              class="pl-2 menu w-80 h-full"
            >
              <li v-if="canAccessBilling">
                <button
                  class="flex items-center gap-3 px-4 py-2 rounded-lg text-left w-full hover:bg-base-300"
                  :disabled="billingActionInFlight"
                  :class="billingActionInFlight ? 'opacity-60 cursor-not-allowed' : ''"
                  @click.stop="handleBillingClick"
                >
                  <CreditCardIcon class="h-5 w-5" aria-hidden="true" />
                  <span>Billing</span>
                </button>
              </li>
              <li>
                <div @click="logout()">
                  <ArrowRightStartOnRectangleIcon
                    class="h-5 w-5"
                    aria-hidden="true"
                  />
                  Logout
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dialog id="my_modal_3" class="modal">
    <div class="modal-box">
      <form method="dialog">
        <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
          ✕
        </button>
      </form>
      <h3 class="text-lg font-bold">Unlock more with Surtly Pro</h3>
      <ul class="pt-2">
        <li>
          - Give your clients each their own link so they can place orders
        </li>
        <li>- Add photos to your products</li>
        <li>- Unlimited orders</li>
      </ul>

      <p class="py-4">$19/month</p>

      <button
        v-if="canAccessBilling"
        class="btn btn-primary text-white no-animation btn-sm w-full"
        :class="billingActionInFlight ? 'btn-disabled opacity-70' : ''"
        :disabled="billingActionInFlight"
        @click="handleBillingClick"
      >
        Billing
      </button>
    </div>
  </dialog>

</template>

<script>
import {
  ArrowRightStartOnRectangleIcon,
  CreditCardIcon,
} from "@heroicons/vue/24/outline";
import { useRoute, useRouter } from "vue-router";
import { onMounted, onBeforeUnmount, computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useLoading } from "vue-loading-overlay";
import { useToast } from "vue-toast-notification";
import axios from "@/axios.js";
import Navigation from "@/components/Navigation.vue";
import { supabaseClient, getDeniedPermissions } from "@/helpers/utils.js";
import { isAuthSessionError } from "@/helpers/authErrors.js";
import {
  isAccessBucketAllowed,
  canAccessProviderRoute,
  hasAnyAllowedAccessBucket,
  resolveProviderAccessRedirect,
} from "@/helpers/providerAccess.js";
import { refreshCurrentUserContext } from "@/helpers/authContext.js";

export default {
  name: "App",
  components: {
    ArrowRightStartOnRectangleIcon,
    CreditCardIcon,
    Navigation,
  },
  setup() {
    const USER_CONTEXT_REFRESH_INTERVAL_MS = 5 * 60 * 1000;
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const toast = useToast();
    const user = ref(null);
    const pro = ref(false);
    const billingActionInFlight = ref(false);
    let userContextRefreshInterval = null;
    let visibilityChangeHandler = null;

    const loading = useLoading({
      color: "#4793AF",
      loader: "spinner",
      "z-index": 99999,
    });

    const persistSession = () => {
      try {
        localStorage.setItem(
          "enlazado_session",
          JSON.stringify(store.state.session || null)
        );
      } catch (error) {
        console.error("Failed to persist session", error);
      }
    };

    const clearSessionState = () => {
      store.commit("setSession", null);

      try {
        localStorage.setItem("enlazado_session", "null");
      } catch (error) {
        console.error("Failed to clear persisted session", error);
      }
    };

    const syncSupabaseAuthSession = (sessionTokens) => {
      if (sessionTokens?.access_token && sessionTokens?.refresh_token) {
        supabaseClient.auth
          .setSession({
            access_token: sessionTokens.access_token,
            refresh_token: sessionTokens.refresh_token,
          })
          .catch((error) => {
            console.error("Failed to apply Supabase session", error);
          });
        return;
      }

      supabaseClient.auth.signOut().catch((error) => {
        console.error("Failed to clear Supabase session", error);
      });
    };

    watch(
      () => store.state.session?.user?.session,
      (sessionTokens) => {
        syncSupabaseAuthSession(sessionTokens);
        persistSession();
      }
    );

    const currentProviderId = computed(
      () => route?.params?.provider_id || null
    );

    const providerMemberships = computed(
      () => store.state.session?.providers || []
    );

    const currentMembership = computed(() => {
      if (!currentProviderId.value) return null;

      return (
        providerMemberships.value.find((membership) => {
          const providerId =
            membership?.provider?.id ??
            membership?.provider_id ??
            membership?.provider?.provider_id ??
            null;

          if (!providerId) return false;

          return String(providerId) === String(currentProviderId.value);
        }) || null
      );
    });

    const isPrimaryMembership = computed(() => {
      const membership = currentMembership.value;
      if (!membership) return false;

      return !membership.invited_by;
    });

    const deniedPermissions = computed(() => {
      const membership = currentMembership.value;
      if (!membership) {
        return [];
      }

      return Array.isArray(membership.permissions_denied)
        ? membership.permissions_denied
        : [];
    });

    const isProviderRoute = computed(
      () =>
        !!(
          route?.name &&
          route.name.startsWith("Provider_") &&
          currentProviderId.value
        )
    );

    const canAccessBilling = computed(
      () =>
        isProviderRoute.value &&
        isPrimaryMembership.value &&
        isAccessBucketAllowed(deniedPermissions.value, "admin")
    );

    async function handleBillingClick() {
      if (!canAccessBilling.value || billingActionInFlight.value) {
        return;
      }

      billingActionInFlight.value = true;
      const loader = loading.show();

      try {
        const { data } = await axios({
          method: "post",
          url: `/api/billing/${currentProviderId.value}/link`,
        });

        if (!data?.url) {
          throw new Error("Missing billing URL");
        }

        window.location.href = data.url;
      } catch (error) {
        console.error("Billing link error", error);
        const message = error?.response?.data?.error || error.message || "Please try again";
        alert(message);
      } finally {
        billingActionInFlight.value = false;
        loader.hide();
      }
    }

    function isAuthRoute(name) {
      return (
        name === "Login" ||
        name === "Signup" ||
        name === "OTP Login" ||
        name === "Reset Password" ||
        name === "Auth Continue Recovery" ||
        name === "Auth Continue Invite" ||
        name === "Invite"
      );
    }

    function readAuthRedirectError() {
      if (typeof window === "undefined") {
        return null;
      }

      const hash = window.location.hash.startsWith("#")
        ? window.location.hash.slice(1)
        : window.location.hash;

      if (!hash) {
        return null;
      }

      const params = new URLSearchParams(hash);
      const error = params.get("error");
      const errorCode = params.get("error_code");
      const errorDescription = params.get("error_description");

      if (!error && !errorCode && !errorDescription) {
        return null;
      }

      return {
        error,
        errorCode,
        errorDescription,
      };
    }

    function getAuthRedirectErrorMessage(authError) {
      if (!authError) {
        return "";
      }

      if (authError.errorCode === "otp_expired") {
        return "Email link is invalid or has expired. Please request a new one.";
      }

      if (authError.errorDescription) {
        return authError.errorDescription;
      }

      return "This email link is invalid or has expired.";
    }

    function clearLocationHash() {
      if (typeof window === "undefined") {
        return;
      }

      const nextUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, "", nextUrl);
    }

    function handleAuthRedirectError() {
      const authError = readAuthRedirectError();

      if (!authError) {
        return;
      }

      toast.error(getAuthRedirectErrorMessage(authError), {
        position: "top-right",
      });

      clearLocationHash();
    }

    function shouldRefreshUserContext() {
      return !isAuthRoute(route.name) && Boolean(store.state.session);
    }

    async function syncUserContext() {
      if (!shouldRefreshUserContext()) {
        return;
      }

      try {
        await refreshCurrentUserContext(store);
        await enforceCurrentProviderRouteAccess();
      } catch (error) {
        if (isAuthSessionError(error)) {
          clearSessionState();
          await router.replace("/login");
          return;
        }

        console.error("Failed to refresh authenticated user context", error);
      }
    }

    async function enforceCurrentProviderRouteAccess() {
      const routeName =
        typeof route?.name === "string" ? route.name : String(route?.name || "");
      if (!routeName.startsWith("Provider_")) {
        return;
      }

      const providerId = route?.params?.provider_id || null;
      if (!providerId) {
        return;
      }

      const deniedPermissions = getDeniedPermissions(store.state.session, providerId);

      if (!hasAnyAllowedAccessBucket(deniedPermissions)) {
        clearSessionState();
        await router.replace("/login");
        return;
      }

      if (!canAccessProviderRoute(routeName, deniedPermissions)) {
        const redirectTarget = resolveProviderAccessRedirect(
          providerId,
          deniedPermissions
        );

        if (!redirectTarget || redirectTarget.name === routeName) {
          clearSessionState();
          await router.replace("/login");
          return;
        }

        await router.replace(redirectTarget);
      }
    }

    onMounted(async () => {
      await router.isReady();
      handleAuthRedirectError();
      const routeName = route.name;
      const shouldResetSessionForAuthScreen =
        routeName === "Login" ||
        routeName === "Signup" ||
        routeName === "OTP Login";

      if (shouldResetSessionForAuthScreen) {
        clearSessionState();
        return;
      }

      let session = null;
      try {
        session = JSON.parse(localStorage.getItem("enlazado_session"));
        store.commit("setSession", session);
      } catch (e) {
        console.log(e);
      }

      if (session?.user?.session) {
        syncSupabaseAuthSession(session.user.session);
        persistSession();
      }

      await syncUserContext();

      visibilityChangeHandler = async () => {
        if (document.visibilityState !== "visible") {
          return;
        }

        await syncUserContext();
      };
      document.addEventListener("visibilitychange", visibilityChangeHandler);

      userContextRefreshInterval = window.setInterval(() => {
        syncUserContext();
      }, USER_CONTEXT_REFRESH_INTERVAL_MS);

      const name = route.name;
      console.log(name);

      if (route.name == "Home") {
        // try {
        // 	router.push(`/provider/${store.state.session.providers[0].id}/inbox`)
        // } catch(e) {
        // 	console.log(e)
        // }
      }
    });

    watch(
      () => route.fullPath,
      () => {
        handleAuthRedirectError();
      }
    );

    onBeforeUnmount(() => {
      if (visibilityChangeHandler) {
        document.removeEventListener("visibilitychange", visibilityChangeHandler);
      }

      if (userContextRefreshInterval) {
        window.clearInterval(userContextRefreshInterval);
      }
    });

    const showNav = computed(() => {
      if (route.meta?.public === true) {
        return false;
      }

      if (route.path == "/") {
        return false;
      } else if (route.name == "Login") {
        return false;
      } else if (route.name == "Provider_Order_Print") {
        return false;
      } else if (route.name == "Signup") {
        return false;
      } else if (route.name == "OTP Login") {
        return false;
      } else if (route.name == "Reset Password") {
        return false;
      } else if (
        route.name == "Auth Continue Recovery" ||
        route.name == "Auth Continue Invite"
      ) {
        return false;
      } else if (route.name == "Invite") {
        return false;
      } else {
        return true;
      }
    });

    function toggle() {
      var box = document.getElementById("my-drawer-3");
      box.checked = !box.checked;
    }

    async function logout() {
      clearSessionState();
      await router.push("/login");
    }

    function showModal() {
      document.getElementById("my_modal_3").showModal();
    }

    return {
      session: computed(() => store.state.session),
      route,
      showNav,
      billingActionInFlight,
      handleBillingClick,
      isProviderRoute,
      canAccessBilling,
      user,
      toggle,
      logout,
      showModal,
      pro,
    };
  },
};
</script>
